import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propShape } from '../../../helpers/custom-prop-types';
import DateText from './DateText';
const PlainDatePickerHeader = (props) => {
    const { date, decreaseMonth, increaseMonth } = props;
    return (_jsxs("div", Object.assign({ className: 'plain_date_picker_custom_header' }, { children: [_jsx("button", { "aria-label": 'Previous Month', className: 'react-datepicker__navigation react-datepicker__navigation--previous', onClick: decreaseMonth, type: 'button' }), _jsx("div", { children: _jsx(DateText, { format: 'YYYY年MM月', value: date }) }), _jsx("button", { "aria-label": 'Next Month', className: 'react-datepicker__navigation react-datepicker__navigation--next', onClick: increaseMonth, type: 'button' })] })));
};
PlainDatePickerHeader.propTypes = {
    date: propShape(),
    decreaseMonth: propFunc().isRequired,
    increaseMonth: propFunc().isRequired,
};
PlainDatePickerHeader.defaultProps = {
    date: undefined,
};
export default PlainDatePickerHeader;
